import { render, staticRenderFns } from "./TabRelationSalesInvoices.vue?vue&type=template&id=a3edf87e"
import script from "./TabRelationSalesInvoices.vue?vue&type=script&setup=true&lang=js"
export * from "./TabRelationSalesInvoices.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports